import { render, staticRenderFns } from "./product-info.vue?vue&type=template&id=17897a12&scoped=true"
import script from "./product-info.vue?vue&type=script&lang=ts"
export * from "./product-info.vue?vue&type=script&lang=ts"
import style0 from "./product-info.vue?vue&type=style&index=0&id=17897a12&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17897a12",
  null
  
)

export default component.exports